<template>
    <div class="col-12 row form-group">
        <div class='col-6'>
            <b-form-group label="Start Datetime" label-for="start_datetime">
                <date-picker v-model="startDate" :type="'datetime'"></date-picker>
            </b-form-group>
        </div>
        <div class='col-6'>
            <b-form-group label="End Datetime" label-for="end_datetime">
                <date-picker v-model="endDate" :type="'datetime'"></date-picker>
            </b-form-group>
        </div>
        <div class="col-12">
            <label class="my-0 mt-2" for="input-live">Queue</label>
            <v-select id="day" label="name" v-model="queue" :options="queueList"
                :reduce="(option) => option._id"></v-select>
        </div>
    </div>
</template>

<script>
import { requestService } from '../../../_services';
export default {
    props: {
        // field: Array,
    },
    data() {
        return {
            startDate: null,
            endDate: null,
            queue: '',
            queueList: []
        };
    },

    async mounted() {
        this.getQueue()
    },
    methods: {
        getFilter() {
            const object = {
                date_start: this.startDate,
                date_end: this.endDate,
                queue: this.queue
            };

            return object;
        },
        getQueue() {
            let url = `/api/mail/queue_management`;
            // ?page = ${ this.currentPage }& limit=${ this.perPage }
            requestService
                .GetFetch('ccp', url)
                .then((res) => {
                    if (res.status == 200) {
                        res.text().then(async (text) => {
                            const data = text && JSON.parse(text);
                            this.queueList = await data.data
                        });
                    }
                }).catch((err) => {

                })
        },
    },
};
</script>

<style>
.vs__search {
    border: 0 !important;
}
</style>